
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { getToken } from '../../../helpers/Helper';
import { del, post } from '../../../helpers/api_helper';
import { POST_UNITS_LIST, DELETE_UNITS, POST_UPDATE_UNITS_STATUS } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import { useTranslation } from 'react-i18next';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";



const UnitsList = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [unitId, SetunitId] = useState(0);


    useMounted(() => {
        getList()
    })

    const getList = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [3, 4] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_UNITS_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "unitId" },
                    { "data": "unitName" },
                    { "data": "unitCode" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button onClick={UpdateStatus.bind(this, data.unitId, data.unitStatus)} className={`border-0 badge ${(data.unitStatus === 'Active') ? 'bg-success' : 'bg-danger'}`}>{data.unitStatus}</button>
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button className="btn btn-sm text-primary mr-2" onClick={() => { navigate('/units/edit/' + data.unitId); }} ><i className="bx bx-edit"></i></button>
                                <button className="btn btn-sm text-danger" onClick={() => { SetunitId(data.unitId); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>
                            </>)
                        }
                    },
                ]
            });
        }
    }

    //UpdateStatus
    const UpdateStatus = async (unitId, status) => {
        var res_data = await post(POST_UPDATE_UNITS_STATUS, { unitId: unitId, status: status });
        if (res_data.status) {
            toast(res_data.message);
            getList();
        } else {
            toast.error(res_data.message);
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(DELETE_UNITS + "?unitId=" + unitId);
        if (res_data.status) {
            toast(res_data.message);
            getList();
        } else {
            toast.error(res_data.message);
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-8'>
                                    <h5 className='mt-1'>{t('units.list.title')}</h5>
                                </div>
                                <div className='col-4 text-right'>
                                    <Link to='/units/add' className='btn btn-sm btn-primary'>+ {t('add')}</Link>
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Id</td>
                                            <td>{t('units.list.unitName')}</td>
                                            <td>{t('units.list.unitCode')}</td>
                                            <td>{t('units.list.status')}</td>
                                            <td>{t('units.list.action')}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t('delete.title')}</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>{t('delete.message')}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t('delete.no')}</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">{t('delete.yes')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UnitsList;